export default "__VITE_ASSET__tfvFFmAz__"